/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/insurance/insurance-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/feature/insurance/insurance.service';
import * as import6 from '../../../../../public/upgrade/feature/insurance/insurance-validations.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/http/src/http';
import * as import11 from '@angular/core/src/zone/ng_zone';
import * as import12 from '@angular/router/src/router_state';
import * as import13 from '@angular/router/src/router';
import * as import14 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import15 from '@angular/forms/src/form_builder';
import * as import16 from '../../../../../public/upgrade/root/modal/modal.service';
import * as import17 from '../../../../../public/upgrade/core/session.service';
import * as import18 from '../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import19 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import20 from '../../../../../public/upgrade/shared/radio-container/radio-container.component';
import * as import21 from '../../shared/radio-container/radio-container.component.ngfactory';
import * as import22 from '@ngx-translate/core/src/translate.pipe';
import * as import23 from '@angular/core/src/linker/view_container';
import * as import24 from '@ngx-translate/core/src/translate.service';
import * as import25 from '@angular/core/src/change_detection/change_detection_util';
import * as import26 from '../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import27 from '../../shared/input-container/input-container.component.ngfactory';
import * as import28 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import29 from '@angular/core/src/linker/template_ref';
import * as import30 from '@angular/common/src/directives/ng_if';
import * as import31 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import32 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import33 from '@angular/common/src/directives/ng_for';
import * as import34 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import35 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import36 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import37 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import38 from '@angular/core/src/linker/element_ref';
import * as import39 from '@angular/common/src/directives/ng_class';
import * as import40 from '@angular/forms/src/directives/ng_form';
import * as import41 from '@angular/forms/src/directives/control_container';
import * as import42 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_InsuranceEditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.InsuranceEditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any) {
    this._changed = false;
    this.context = new import0.InsuranceEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_InsuranceEditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_InsuranceEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.InsuranceEditComponent>;
  _InsuranceService_0_3:import5.InsuranceService;
  _InsuranceValidationsService_0_4:import6.InsuranceValidationsService;
  _InsuranceEditComponent_0_5:Wrapper_InsuranceEditComponent;
  __IncludedPipe_0_6:import0.IncludedPipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InsuranceEditComponent_Host0,renderType_InsuranceEditComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  get _IncludedPipe_0_6():import0.IncludedPipe {
    if ((this.__IncludedPipe_0_6 == null)) { (this.__IncludedPipe_0_6 = new import0.IncludedPipe()); }
    return this.__IncludedPipe_0_6;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'insurance-edit',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_InsuranceEditComponent0(this.viewUtils,this,0,this._el_0);
    this._InsuranceService_0_3 = new import5.InsuranceService(this.injectorGet(import10.Http,this.parentIndex));
    this._InsuranceValidationsService_0_4 = new import6.InsuranceValidationsService();
    this._InsuranceEditComponent_0_5 = new Wrapper_InsuranceEditComponent(this.injectorGet(import11.NgZone,this.parentIndex),this._InsuranceService_0_3,this.injectorGet(import12.ActivatedRoute,this.parentIndex),this.injectorGet(import13.Router,this.parentIndex),this.injectorGet(import14.LoadingWheelService,this.parentIndex),this.injectorGet(import15.FormBuilder,this.parentIndex),this.injectorGet(import16.ModalService,this.parentIndex),this.injectorGet(import17.SessionService,this.parentIndex),this.injectorGet(import18.SidebarService,this.parentIndex),this.injectorGet(import19.NotificationService,this.parentIndex),this._InsuranceValidationsService_0_4);
    this.compView_0.create(this._InsuranceEditComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._InsuranceEditComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.InsuranceService) && (0 === requestNodeIndex))) { return this._InsuranceService_0_3; }
    if (((token === import6.InsuranceValidationsService) && (0 === requestNodeIndex))) { return this._InsuranceValidationsService_0_4; }
    if (((token === import0.InsuranceEditComponent) && (0 === requestNodeIndex))) { return this._InsuranceEditComponent_0_5.context; }
    if (((token === import0.IncludedPipe) && (0 === requestNodeIndex))) { return this._IncludedPipe_0_6; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._InsuranceEditComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const InsuranceEditComponentNgFactory:import9.ComponentFactory<import0.InsuranceEditComponent> = new import9.ComponentFactory<import0.InsuranceEditComponent>('insurance-edit',View_InsuranceEditComponent_Host0,import0.InsuranceEditComponent);
const styles_InsuranceEditComponent:any[] = ([] as any[]);
class View_InsuranceEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import20.RadioContainerComponent>;
  _RadioContainerComponent_2_3:import21.Wrapper_RadioContainerComponent;
  _text_3:any;
  _text_4:any;
  _pipe_translate_0:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent2,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm ellipsisText'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import21.View_RadioContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._RadioContainerComponent_2_3 = new import21.Wrapper_RadioContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_2.create(this._RadioContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._RadioContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.RadioContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._RadioContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_2_0_0:any = this.context.$implicit;
    this._RadioContainerComponent_2_3.check_id(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit;
    this._RadioContainerComponent_2_3.check_value(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'categorySelection';
    this._RadioContainerComponent_2_3.check_name(currVal_2_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_3:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(('cars.category.' + this.context.$implicit)));
    this._RadioContainerComponent_2_3.check_label(currVal_2_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_4:any = this.parentView.parentView.context.isEditing;
    this._RadioContainerComponent_2_3.check_disabled(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.parentView.context.dto.categoryCode;
    this._RadioContainerComponent_2_3.check_model(currVal_2_0_5,throwOnChange,false);
    this._RadioContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._RadioContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto.categoryCode = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_InsuranceEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  compView_9:import1.AppView<import26.InputContainerComponent>;
  _InputContainerComponent_9_3:import27.Wrapper_InputContainerComponent;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_22:any;
  _pipe_translate_0:import22.TranslatePipe;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_25:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent5,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_22 = import25.UNINITIALIZED;
    this._expr_25 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_9 = new import27.View_InputContainerComponent0(this.viewUtils,this,9,this._el_9);
    this._InputContainerComponent_9_3 = new import27.Wrapper_InputContainerComponent();
    this._text_10 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_9.create(this._InputContainerComponent_9_3.context);
    this._text_11 = this.renderer.createText(this._el_7,'\n                                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg -eva-3-pt-md -eva-3-pl-xsm'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                                    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_9,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_9));
    this._InputContainerComponent_9_3.subscribe(this,this.eventHandler(this.handleEvent_9),false,false,true);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.InputContainerComponent) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._InputContainerComponent_9_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_9_0_0:any = 0;
    this._InputContainerComponent_9_3.check_placeholder(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = ('insurancePrice_' + this.parentView.context.$implicit.code);
    this._InputContainerComponent_9_3.check_name(currVal_9_0_1,throwOnChange,false);
    const currVal_9_0_2:boolean = !!this.parentView.parentView.parentView.parentView.context.errors['deductible'];
    this._InputContainerComponent_9_3.check_invalid(currVal_9_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_9_0_3:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.parentView.parentView.parentView.context.errorMessages['deductiblePositive']));
    this._InputContainerComponent_9_3.check_invalidText(currVal_9_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_9_0_4:any = this.parentView.parentView.parentView.parentView.context.dto.deductible[this.parentView.context.$implicit.oid];
    this._InputContainerComponent_9_3.check_model(currVal_9_0_4,throwOnChange,false);
    this._InputContainerComponent_9_3.ngDoCheck(this,this._el_9,throwOnChange);
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('insurancePrice.DEDUCTIBLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_5,currVal_22);
      this._expr_22 = currVal_22;
    }
    const currVal_25:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.parentView.context.currency,'');
    if (import3.checkBinding(throwOnChange,this._expr_25,currVal_25)) {
      this.renderer.setText(this._text_17,currVal_25);
      this._expr_25 = currVal_25;
    }
    this.compView_9.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._InputContainerComponent_9_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_9.destroy();
    this._InputContainerComponent_9_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_9(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.parentView.context.dto.deductible[this.parentView.context.$implicit.oid] = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_InsuranceEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import23.ViewContainer;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import28.Wrapper_NgIf;
  _text_9:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import22.TranslatePipe;
  /*private*/ _expr_15:any;
  _pipe_translate_1:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent4,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import25.UNINITIALIZED;
    this._expr_15 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'h5',new import3.InlineArray4(4,'class','eva-3-h5','qadata','included'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n\n                                ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_8 = new import23.ViewContainer(8,0,this,this._anchor_8);
    this._TemplateRef_8_5 = new import29.TemplateRef_(this,8,this._anchor_8);
    this._NgIf_8_6 = new import28.Wrapper_NgIf(this._vc_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._anchor_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import30.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_8_0_0:any = this.parentView.parentView.parentView.context.isCDWInsurance(this.context.$implicit.code);
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',((this.context.$implicit.code + ' - ') + valUnwrapper.unwrap(this._pipe_translate_0.transform(('insurancePrice.price.' + this.context.$implicit.code)))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_3,currVal_13);
      this._expr_13 = currVal_13;
    }
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform(('insurancePrice.price.description-sm.' + this.context.$implicit.code))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_6,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_8.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 8)) { return new View_InsuranceEditComponent5(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    return (null as any);
  }
}
class View_InsuranceEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import31.Wrapper_NgFor;
  _text_3:any;
  _pipe_includedFilter_0_0:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent3,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n                            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import29.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import31.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.parentView.injectorGet(import32.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_includedFilter_0_0 = import3.pureProxy2((<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0.transform.bind((<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import33.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2_0_0:any = valUnwrapper.unwrap(import3.castByValue(this._pipe_includedFilter_0_0,(<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0.transform)(this.parentView.parentView.context.insurances,true));
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_InsuranceEditComponent4(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_InsuranceEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  compView_9:import1.AppView<import26.InputContainerComponent>;
  _InputContainerComponent_9_3:import27.Wrapper_InputContainerComponent;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_22:any;
  _pipe_translate_0:import22.TranslatePipe;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_25:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent8,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_22 = import25.UNINITIALIZED;
    this._expr_25 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-8 -md-8 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                                                    ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_9 = new import27.View_InputContainerComponent0(this.viewUtils,this,9,this._el_9);
    this._InputContainerComponent_9_3 = new import27.Wrapper_InputContainerComponent();
    this._text_10 = this.renderer.createText((null as any),'\n                                                    ',(null as any));
    this.compView_9.create(this._InputContainerComponent_9_3.context);
    this._text_11 = this.renderer.createText(this._el_7,'\n                                                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg -eva-3-pt-md -eva-3-pl-xsm'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                                ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                                            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_9,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_9));
    this._InputContainerComponent_9_3.subscribe(this,this.eventHandler(this.handleEvent_9),false,false,true);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.InputContainerComponent) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._InputContainerComponent_9_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_9_0_0:any = 0;
    this._InputContainerComponent_9_3.check_placeholder(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = ('insurancePrice_' + this.parentView.context.$implicit.code);
    this._InputContainerComponent_9_3.check_name(currVal_9_0_1,throwOnChange,false);
    const currVal_9_0_2:boolean = !!this.parentView.parentView.parentView.parentView.context.errors['deductible'];
    this._InputContainerComponent_9_3.check_invalid(currVal_9_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_9_0_3:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.parentView.parentView.parentView.context.errorMessages['deductiblePositive']));
    this._InputContainerComponent_9_3.check_invalidText(currVal_9_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_9_0_4:any = this.parentView.parentView.parentView.parentView.context.dto.deductible[this.parentView.context.$implicit.oid];
    this._InputContainerComponent_9_3.check_model(currVal_9_0_4,throwOnChange,false);
    this._InputContainerComponent_9_3.ngDoCheck(this,this._el_9,throwOnChange);
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('insurancePrice.DEDUCTIBLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_5,currVal_22);
      this._expr_22 = currVal_22;
    }
    const currVal_25:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.parentView.context.currency,'');
    if (import3.checkBinding(throwOnChange,this._expr_25,currVal_25)) {
      this.renderer.setText(this._text_17,currVal_25);
      this._expr_25 = currVal_25;
    }
    this.compView_9.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._InputContainerComponent_9_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_9.destroy();
    this._InputContainerComponent_9_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_9(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.parentView.context.dto.deductible[this.parentView.context.$implicit.oid] = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_InsuranceEditComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  /*private*/ _expr_11:any;
  /*private*/ _expr_12:any;
  _pipe_translate_0:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent9,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_11 = import25.UNINITIALIZED;
    this._expr_12 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-12 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'dsp-message',new import3.InlineArray4(4,'closable','false','type','warning'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'p',new import3.InlineArray2(2,'class','eva-3-p message-text -eva-3-pt-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_11:boolean = !this.parentView.parentView.parentView.parentView.context.warningOn;
    if (import3.checkBinding(throwOnChange,this._expr_11,currVal_11)) {
      this.renderer.setElementProperty(this._el_0,'hidden',currVal_11);
      this._expr_11 = currVal_11;
    }
    valUnwrapper.reset();
    const currVal_12:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('insurancePrice.CDW_WARNING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_7,currVal_12);
      this._expr_12 = currVal_12;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_InsuranceEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  compView_19:import1.AppView<import26.InputContainerComponent>;
  _InputContainerComponent_19_3:import27.Wrapper_InputContainerComponent;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _vc_33:import23.ViewContainer;
  _TemplateRef_33_5:any;
  _NgIf_33_6:import28.Wrapper_NgIf;
  _text_34:any;
  _text_35:any;
  _anchor_36:any;
  /*private*/ _vc_36:import23.ViewContainer;
  _TemplateRef_36_5:any;
  _NgIf_36_6:import28.Wrapper_NgIf;
  _text_37:any;
  _text_38:any;
  /*private*/ _expr_47:any;
  _pipe_translate_0:import22.TranslatePipe;
  /*private*/ _expr_49:any;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_51:any;
  _pipe_translate_2:import22.TranslatePipe;
  _pipe_translate_3:import22.TranslatePipe;
  /*private*/ _expr_54:any;
  _pipe_translate_4:import22.TranslatePipe;
  /*private*/ _expr_56:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent7,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_47 = import25.UNINITIALIZED;
    this._expr_49 = import25.UNINITIALIZED;
    this._expr_51 = import25.UNINITIALIZED;
    this._expr_54 = import25.UNINITIALIZED;
    this._expr_56 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'h5',new import3.InlineArray4(4,'class','eva-3-h5','qadata','additional'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-12 -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n\n                                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','col -lg-8 -md-8 -sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n                                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_19 = new import27.View_InputContainerComponent0(this.viewUtils,this,19,this._el_19);
    this._InputContainerComponent_19_3 = new import27.Wrapper_InputContainerComponent();
    this._text_20 = this.renderer.createText((null as any),'\n                                                ',(null as any));
    this.compView_19.create(this._InputContainerComponent_19_3.context);
    this._text_21 = this.renderer.createText(this._el_17,'\n                                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_12,'\n                                            ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_12,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_12,'\n                                        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_10,'\n                                        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','-lg-2 -md-4 -sm-6 -eva-3-mt-lg -eva-3-pt-md -eva-3-pl-xsm'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                                            ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'',(null as any));
    this._text_31 = this.renderer.createText(this._el_27,'\n                                        ',(null as any));
    this._text_32 = this.renderer.createText(this._el_10,'\n\n\n                                        ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_10,(null as any));
    this._vc_33 = new import23.ViewContainer(33,10,this,this._anchor_33);
    this._TemplateRef_33_5 = new import29.TemplateRef_(this,33,this._anchor_33);
    this._NgIf_33_6 = new import28.Wrapper_NgIf(this._vc_33.vcRef,this._TemplateRef_33_5);
    this._text_34 = this.renderer.createText(this._el_10,'\n\n\n                                    ',(null as any));
    this._text_35 = this.renderer.createText(this._el_8,'\n\n                                    ',(null as any));
    this._anchor_36 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._vc_36 = new import23.ViewContainer(36,8,this,this._anchor_36);
    this._TemplateRef_36_5 = new import29.TemplateRef_(this,36,this._anchor_36);
    this._NgIf_36_6 = new import28.Wrapper_NgIf(this._vc_36.vcRef,this._TemplateRef_36_5);
    this._text_37 = this.renderer.createText(this._el_8,'\n                                ',(null as any));
    this._text_38 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_2 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_19,new import3.InlineArray4(4,'modelChange',(null as any),'focus',(null as any)),this.eventHandler(this.handleEvent_19));
    this._InputContainerComponent_19_3.subscribe(this,this.eventHandler(this.handleEvent_19),false,false,true);
    this._pipe_translate_3 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this._pipe_translate_4 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._text_35,
      this._anchor_36,
      this._text_37,
      this._text_38
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.InputContainerComponent) && ((19 <= requestNodeIndex) && (requestNodeIndex <= 20)))) { return this._InputContainerComponent_19_3.context; }
    if (((token === import29.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import30.NgIf) && (33 === requestNodeIndex))) { return this._NgIf_33_6.context; }
    if (((token === import29.TemplateRef) && (36 === requestNodeIndex))) { return this._TemplateRef_36_5; }
    if (((token === import30.NgIf) && (36 === requestNodeIndex))) { return this._NgIf_36_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    const currVal_19_0_0:any = 0;
    this._InputContainerComponent_19_3.check_placeholder(currVal_19_0_0,throwOnChange,false);
    const currVal_19_0_1:any = ('insurancePrice_' + this.context.$implicit.code);
    this._InputContainerComponent_19_3.check_name(currVal_19_0_1,throwOnChange,false);
    const currVal_19_0_2:boolean = !!this.parentView.parentView.parentView.context.errors['basesAmount'];
    this._InputContainerComponent_19_3.check_invalid(currVal_19_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_19_0_3:any = valUnwrapper.unwrap(this._pipe_translate_3.transform(this.parentView.parentView.parentView.context.errorMessages['basesAmount']));
    this._InputContainerComponent_19_3.check_invalidText(currVal_19_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_19_0_4:any = this.parentView.parentView.parentView.context.dto.basesAmount[this.context.$implicit.oid];
    this._InputContainerComponent_19_3.check_model(currVal_19_0_4,throwOnChange,false);
    this._InputContainerComponent_19_3.ngDoCheck(this,this._el_19,throwOnChange);
    const currVal_33_0_0:any = this.parentView.parentView.parentView.context.isCDWInsurance(this.context.$implicit.code);
    this._NgIf_33_6.check_ngIf(currVal_33_0_0,throwOnChange,false);
    this._NgIf_33_6.ngDoCheck(this,this._anchor_33,throwOnChange);
    const currVal_36_0_0:any = (this.context.$implicit.code == 'CDW');
    this._NgIf_36_6.check_ngIf(currVal_36_0_0,throwOnChange,false);
    this._NgIf_36_6.ngDoCheck(this,this._anchor_36,throwOnChange);
    this._vc_33.detectChangesInNestedViews(throwOnChange);
    this._vc_36.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_47:any = import3.inlineInterpolate(1,'',((this.context.$implicit.code + ' - ') + valUnwrapper.unwrap(this._pipe_translate_0.transform(('insurancePrice.price.' + this.context.$implicit.code)))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_47,currVal_47))) {
      this.renderer.setText(this._text_3,currVal_47);
      this._expr_47 = currVal_47;
    }
    valUnwrapper.reset();
    const currVal_49:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform(('insurancePrice.price.description.' + this.context.$implicit.code))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_49,currVal_49))) {
      this.renderer.setText(this._text_6,currVal_49);
      this._expr_49 = currVal_49;
    }
    valUnwrapper.reset();
    const currVal_51:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('insurancePrice.DAILY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_51,currVal_51))) {
      this.renderer.setText(this._text_15,currVal_51);
      this._expr_51 = currVal_51;
    }
    valUnwrapper.reset();
    const currVal_54:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform(this.parentView.parentView.parentView.context.errorMessages['insurancePrice'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_54,currVal_54))) {
      this.renderer.setText(this._text_24,currVal_54);
      this._expr_54 = currVal_54;
    }
    const currVal_56:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.currency,'');
    if (import3.checkBinding(throwOnChange,this._expr_56,currVal_56)) {
      this.renderer.setText(this._text_30,currVal_56);
      this._expr_56 = currVal_56;
    }
    this.compView_19.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._InputContainerComponent_19_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_33.destroyNestedViews();
    this._vc_36.destroyNestedViews();
    this.compView_19.destroy();
    this._InputContainerComponent_19_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 33)) { return new View_InsuranceEditComponent8(this.viewUtils,this,33,this._anchor_33,this._vc_33); }
    if ((nodeIndex == 36)) { return new View_InsuranceEditComponent9(this.viewUtils,this,36,this._anchor_36,this._vc_36); }
    return (null as any);
  }
  handleEvent_19(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.context.dto.basesAmount[this.context.$implicit.oid] = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'focus')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.parentView.context.setWarning()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_InsuranceEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import31.Wrapper_NgFor;
  _text_3:any;
  _pipe_includedFilter_0_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent6,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','eva-3-row','qadata','additional-insurances'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n                            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import29.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import31.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.parentView.injectorGet(import32.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_includedFilter_0_1 = import3.pureProxy2((<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0.transform.bind((<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import33.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2_0_0:any = valUnwrapper.unwrap(import3.castByValue(this._pipe_includedFilter_0_1,(<View_InsuranceEditComponent0>this.parentView.parentView)._pipe_includedFilter_0.transform)(this.parentView.parentView.context.insurances,false));
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_InsuranceEditComponent7(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_InsuranceEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _NgForm_0_3:import34.Wrapper_NgForm;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import35.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _NgClass_12_3:import36.Wrapper_NgClass;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _anchor_27:any;
  /*private*/ _vc_27:import23.ViewContainer;
  _TemplateRef_27_5:any;
  _NgFor_27_6:import31.Wrapper_NgFor;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  _anchor_49:any;
  /*private*/ _vc_49:import23.ViewContainer;
  _TemplateRef_49_5:any;
  _NgIf_49_6:import28.Wrapper_NgIf;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _el_57:any;
  _NgClass_57_3:import36.Wrapper_NgClass;
  _text_58:any;
  _el_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _text_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _text_83:any;
  _anchor_84:any;
  /*private*/ _vc_84:import23.ViewContainer;
  _TemplateRef_84_5:any;
  _NgIf_84_6:import28.Wrapper_NgIf;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _el_88:any;
  _text_89:any;
  _el_90:any;
  _text_91:any;
  _el_92:any;
  _text_93:any;
  _el_94:any;
  _text_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _text_102:any;
  _text_103:any;
  /*private*/ _expr_118:any;
  _pipe_translate_0:import22.TranslatePipe;
  _map_120:any;
  /*private*/ _expr_121:any;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_123:any;
  _pipe_translate_2:import22.TranslatePipe;
  /*private*/ _expr_125:any;
  _pipe_translate_3:import22.TranslatePipe;
  _map_127:any;
  /*private*/ _expr_128:any;
  _pipe_translate_4:import22.TranslatePipe;
  /*private*/ _expr_130:any;
  _pipe_translate_5:import22.TranslatePipe;
  /*private*/ _expr_132:any;
  _pipe_translate_6:import22.TranslatePipe;
  /*private*/ _expr_134:any;
  _pipe_translate_7:import22.TranslatePipe;
  /*private*/ _expr_136:any;
  _pipe_translate_8:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_InsuranceEditComponent1,renderType_InsuranceEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_118 = import25.UNINITIALIZED;
    this._map_120 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_121 = import25.UNINITIALIZED;
    this._expr_123 = import25.UNINITIALIZED;
    this._expr_125 = import25.UNINITIALIZED;
    this._map_127 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_128 = import25.UNINITIALIZED;
    this._expr_130 = import25.UNINITIALIZED;
    this._expr_132 = import25.UNINITIALIZED;
    this._expr_134 = import25.UNINITIALIZED;
    this._expr_136 = import25.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'form',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgForm_0_3 = new import34.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_0_4 = this._NgForm_0_3.context;
    this._NgControlStatusGroup_0_5 = new import35.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h2',new import3.InlineArray2(2,'class','eva-3-h2 -eva-3-pb-md'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_12_3 = new import36.Wrapper_NgClass(this.parentView.parentView.injectorGet(import32.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import37.KeyValueDiffers,this.parentView.parentIndex),new import38.ElementRef(this._el_12),this.renderer);
    this._text_13 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray4(4,'class','eva-3-panel-info -eva-3-bc-white','qadata','car-categories'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n\n                            ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                                ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                                    ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_18,'\n                                ',(null as any));
    this._text_23 = this.renderer.createText(this._el_16,'\n                            ',(null as any));
    this._text_24 = this.renderer.createText(this._el_14,'\n\n                            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_14,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                                ',(null as any));
    this._anchor_27 = this.renderer.createTemplateAnchor(this._el_25,(null as any));
    this._vc_27 = new import23.ViewContainer(27,25,this,this._anchor_27);
    this._TemplateRef_27_5 = new import29.TemplateRef_(this,27,this._anchor_27);
    this._NgFor_27_6 = new import31.Wrapper_NgFor(this._vc_27.vcRef,this._TemplateRef_27_5,this.parentView.parentView.injectorGet(import32.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_28 = this.renderer.createText(this._el_25,'\n                            ',(null as any));
    this._text_29 = this.renderer.createText(this._el_14,'\n                        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_12,'span',new import3.InlineArray4(4,'class','validation-msg','qadata','car-categories-error'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_12,'\n                    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_10,'\n                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                    ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray4(4,'class','eva-3-panel-info -eva-3-bc-white','qadata','CDW'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                        ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                                ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_42,'\n                            ',(null as any));
    this._text_47 = this.renderer.createText(this._el_40,'\n                        ',(null as any));
    this._text_48 = this.renderer.createText(this._el_38,'\n\n                        ',(null as any));
    this._anchor_49 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._vc_49 = new import23.ViewContainer(49,38,this,this._anchor_49);
    this._TemplateRef_49_5 = new import29.TemplateRef_(this,49,this._anchor_49);
    this._NgIf_49_6 = new import28.Wrapper_NgIf(this._vc_49.vcRef,this._TemplateRef_49_5);
    this._text_50 = this.renderer.createText(this._el_38,'\n                    ',(null as any));
    this._text_51 = this.renderer.createText(this._el_36,'\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n\n                    ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'\n                        ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_57_3 = new import36.Wrapper_NgClass(this.parentView.parentView.injectorGet(import32.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import37.KeyValueDiffers,this.parentView.parentIndex),new import38.ElementRef(this._el_57),this.renderer);
    this._text_58 = this.renderer.createText(this._el_57,'\n\n                            ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_57,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_60 = this.renderer.createText(this._el_59,'\n                                ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_59,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                                    ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'',(null as any));
    this._text_65 = this.renderer.createText(this._el_61,'\n                                ',(null as any));
    this._text_66 = this.renderer.createText(this._el_59,'\n                            ',(null as any));
    this._text_67 = this.renderer.createText(this._el_57,'\n                            ',(null as any));
    this._el_68 = import3.createRenderElement(this.renderer,this._el_57,'span',new import3.InlineArray2(2,'class','validation-msg -additional-insurances-error'),(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'',(null as any));
    this._text_70 = this.renderer.createText(this._el_57,'\n\n                        ',(null as any));
    this._text_71 = this.renderer.createText(this._el_55,'\n                        ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                            ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_72,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'\n                                ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_74,'dsp-message',new import3.InlineArray2(2,'closable','false'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'\n                                    ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_76,'p',new import3.InlineArray2(2,'class','eva-3-p message-text -eva-3-pt-sm'),(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'',(null as any));
    this._text_80 = this.renderer.createText(this._el_76,'\n                                ',(null as any));
    this._text_81 = this.renderer.createText(this._el_74,'\n                            ',(null as any));
    this._text_82 = this.renderer.createText(this._el_72,'\n                        ',(null as any));
    this._text_83 = this.renderer.createText(this._el_55,'\n\n                        ',(null as any));
    this._anchor_84 = this.renderer.createTemplateAnchor(this._el_55,(null as any));
    this._vc_84 = new import23.ViewContainer(84,55,this,this._anchor_84);
    this._TemplateRef_84_5 = new import29.TemplateRef_(this,84,this._anchor_84);
    this._NgIf_84_6 = new import28.Wrapper_NgIf(this._vc_84.vcRef,this._TemplateRef_84_5);
    this._text_85 = this.renderer.createText(this._el_55,'\n                    ',(null as any));
    this._text_86 = this.renderer.createText(this._el_53,'\n                ',(null as any));
    this._text_87 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_88 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_89 = this.renderer.createText(this._el_88,'\n                    ',(null as any));
    this._el_90 = import3.createRenderElement(this.renderer,this._el_88,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_91 = this.renderer.createText(this._el_90,'\n                        ',(null as any));
    this._el_92 = import3.createRenderElement(this.renderer,this._el_90,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_93 = this.renderer.createText(this._el_92,'\n                            ',(null as any));
    this._el_94 = import3.createRenderElement(this.renderer,this._el_92,'dsp-button',new import3.InlineArray8(6,'qadata','save','size','md','variation','primary'),(null as any));
    this._text_95 = this.renderer.createText(this._el_94,'',(null as any));
    this._text_96 = this.renderer.createText(this._el_92,'\n                            ',(null as any));
    this._el_97 = import3.createRenderElement(this.renderer,this._el_92,'dsp-button',new import3.InlineArray8(6,'qadata','cancel','size','md','variation','link'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'',(null as any));
    this._text_99 = this.renderer.createText(this._el_92,'\n                        ',(null as any));
    this._text_100 = this.renderer.createText(this._el_90,'\n                    ',(null as any));
    this._text_101 = this.renderer.createText(this._el_88,'\n                ',(null as any));
    this._text_102 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_103 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_4 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_6 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_94,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_94));
    this._pipe_translate_7 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_97,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_97));
    this._pipe_translate_8 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._anchor_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._text_48,
      this._anchor_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._text_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._text_83,
      this._anchor_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._el_88,
      this._text_89,
      this._el_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._el_94,
      this._text_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._text_101,
      this._text_102,
      this._text_103
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (27 === requestNodeIndex))) { return this._TemplateRef_27_5; }
    if (((token === import33.NgFor) && (27 === requestNodeIndex))) { return this._NgFor_27_6.context; }
    if (((token === import39.NgClass) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._NgClass_12_3.context; }
    if (((token === import29.TemplateRef) && (49 === requestNodeIndex))) { return this._TemplateRef_49_5; }
    if (((token === import30.NgIf) && (49 === requestNodeIndex))) { return this._NgIf_49_6.context; }
    if (((token === import39.NgClass) && ((57 <= requestNodeIndex) && (requestNodeIndex <= 70)))) { return this._NgClass_57_3.context; }
    if (((token === import29.TemplateRef) && (84 === requestNodeIndex))) { return this._TemplateRef_84_5; }
    if (((token === import30.NgIf) && (84 === requestNodeIndex))) { return this._NgIf_84_6.context; }
    if (((token === import40.NgForm) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 103)))) { return this._NgForm_0_3.context; }
    if (((token === import41.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 103)))) { return this._ControlContainer_0_4; }
    if (((token === import42.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 103)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import25.ValueUnwrapper();
    this._NgForm_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_12_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_12_3.check_klass(currVal_12_0_0,throwOnChange,false);
    const currVal_12_0_1:any = this._map_120(!!this.parentView.context.errors['categorySelected']);
    this._NgClass_12_3.check_ngClass(currVal_12_0_1,throwOnChange,false);
    this._NgClass_12_3.ngDoCheck(this,this._el_12,throwOnChange);
    const currVal_27_0_0:any = this.parentView.context.categories;
    this._NgFor_27_6.check_ngForOf(currVal_27_0_0,throwOnChange,false);
    this._NgFor_27_6.ngDoCheck(this,this._anchor_27,throwOnChange);
    const currVal_49_0_0:boolean = !!this.parentView.context.insurances;
    this._NgIf_49_6.check_ngIf(currVal_49_0_0,throwOnChange,false);
    this._NgIf_49_6.ngDoCheck(this,this._anchor_49,throwOnChange);
    const currVal_57_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_57_3.check_klass(currVal_57_0_0,throwOnChange,false);
    const currVal_57_0_1:any = this._map_127(!!this.parentView.context.errors['inputPrice']);
    this._NgClass_57_3.check_ngClass(currVal_57_0_1,throwOnChange,false);
    this._NgClass_57_3.ngDoCheck(this,this._el_57,throwOnChange);
    const currVal_84_0_0:boolean = !!this.parentView.context.insurances;
    this._NgIf_84_6.check_ngIf(currVal_84_0_0,throwOnChange,false);
    this._NgIf_84_6.ngDoCheck(this,this._anchor_84,throwOnChange);
    this._vc_27.detectChangesInNestedViews(throwOnChange);
    this._vc_49.detectChangesInNestedViews(throwOnChange);
    this._vc_84.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_0_5.checkHost(this,this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_118:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('insurancePrice.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_118,currVal_118))) {
      this.renderer.setText(this._text_7,currVal_118);
      this._expr_118 = currVal_118;
    }
    valUnwrapper.reset();
    const currVal_121:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('insurancePrice.CATEGORY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_121,currVal_121))) {
      this.renderer.setText(this._text_21,currVal_121);
      this._expr_121 = currVal_121;
    }
    valUnwrapper.reset();
    const currVal_123:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform(this.parentView.context.errorMessages['categorySelected'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_123,currVal_123))) {
      this.renderer.setText(this._text_32,currVal_123);
      this._expr_123 = currVal_123;
    }
    valUnwrapper.reset();
    const currVal_125:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('insurancePrice.INCLUDED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_125,currVal_125))) {
      this.renderer.setText(this._text_45,currVal_125);
      this._expr_125 = currVal_125;
    }
    valUnwrapper.reset();
    const currVal_128:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('insurancePrice.ADDITIONAL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_128,currVal_128))) {
      this.renderer.setText(this._text_64,currVal_128);
      this._expr_128 = currVal_128;
    }
    valUnwrapper.reset();
    const currVal_130:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform(this.parentView.context.errorMessages['inputPrice'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_130,currVal_130))) {
      this.renderer.setText(this._text_69,currVal_130);
      this._expr_130 = currVal_130;
    }
    valUnwrapper.reset();
    const currVal_132:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('insurancePrice.NO_TAXES_INCLUDED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_132,currVal_132))) {
      this.renderer.setText(this._text_79,currVal_132);
      this._expr_132 = currVal_132;
    }
    valUnwrapper.reset();
    const currVal_134:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_134,currVal_134))) {
      this.renderer.setText(this._text_95,currVal_134);
      this._expr_134 = currVal_134;
    }
    valUnwrapper.reset();
    const currVal_136:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_136,currVal_136))) {
      this.renderer.setText(this._text_98,currVal_136);
      this._expr_136 = currVal_136;
    }
  }
  destroyInternal():void {
    this._vc_27.destroyNestedViews();
    this._vc_49.destroyNestedViews();
    this._vc_84.destroyNestedViews();
    this._NgForm_0_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 27)) { return new View_InsuranceEditComponent2(this.viewUtils,this,27,this._anchor_27,this._vc_27); }
    if ((nodeIndex == 49)) { return new View_InsuranceEditComponent3(this.viewUtils,this,49,this._anchor_49,this._vc_49); }
    if ((nodeIndex == 84)) { return new View_InsuranceEditComponent6(this.viewUtils,this,84,this._anchor_84,this._vc_84); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_0_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_94(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_97(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_InsuranceEditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_InsuranceEditComponent,{});
export class View_InsuranceEditComponent0 extends import1.AppView<import0.InsuranceEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import23.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import28.Wrapper_NgIf;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _pipe_includedFilter_0:import0.IncludedPipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InsuranceEditComponent0,renderType_InsuranceEditComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_4 = new import23.ViewContainer(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import29.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import28.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_7 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._pipe_includedFilter_0 = new import0.IncludedPipe();
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import30.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = this.context.endLoading;
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_4.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 4)) { return new View_InsuranceEditComponent1(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/insurance/insurance-edit.component.ngfactory.ts